import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  MultiMetricComparisonVizConfig,
  MultiMetricComparisonVizExternalProps,
  MultiMetricComparisonVizViews,
} from './types';
import { useMultiMetricComparisonConfigToData } from './useConfigToData';
import { multiMetricComparisonViewConfigs } from './views/view-configs';

export interface MultiMetricComparisonVizProps {
  dataConfig: MultiMetricComparisonVizConfig;
  selectedView: MultiMetricComparisonVizViews;
  externalProps: MultiMetricComparisonVizExternalProps;
  persistenceKey: string;
}

/**
 * A visualization component that compares multiple metrics side by side.
 *
 * Unlike other viz types that group data by a field, this component:
 * - Takes multiple metrics as input
 * - Fetches all metrics in parallel
 * - Displays one bar per metric value
 *
 * Use this when you want to compare the total values of different metrics
 * for the same time period (e.g., comparing headcount, joiners, and leavers).
 */
export const MultiMetricComparisonViz = (
  props: MultiMetricComparisonVizProps
) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useMultiMetricComparisonConfigToData}
      selectedView={props.selectedView}
      viewConfigs={multiMetricComparisonViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
